var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgDefaultProductIcon = function SvgDefaultProductIcon(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 19,
    viewBox: "0 0 24 19",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.9292 16.2374L11.9998 13.7085V3.34009L3.9292 5.84951V16.2374Z",
    fill: "#B7BFCD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M20.0706 16.2374L12 13.7085V3.34009L20.0706 5.84951V16.2374Z",
    fill: "#6D7C9A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.13
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.9292 16.2374L11.9998 13.7085V3.34009L3.9292 5.84951V16.2374Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0704 16.2374L11.9998 13.7085V3.34009L20.0704 5.84951V16.2374Z",
    fill: "url(#paint1_linear)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 18.7858L3.9292 16.2569V5.88849L11.9998 8.41736V18.7858Z",
    fill: "#EDF1F9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 18.7858L20.0706 16.2569V5.88849L12 8.41736V18.7858Z",
    fill: "#DAE1ED"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M10.1713 16.9572L3.9292 16.2569V5.88849L11.9998 8.41736L10.1713 16.9572Z",
    fill: "url(#paint2_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M13.8286 15.1286L20.0706 16.2569V5.88849L12 8.41736L13.8286 15.1286Z",
    fill: "url(#paint3_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12 3.34012L8.20546 0.5L0 3.26231L3.92937 5.84954L12 3.34012Z",
    fill: "#DAE1ED"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12 3.34012L15.7945 0.5L24 3.26231L20.0706 5.84954L12 3.34012Z",
    fill: "#DAE1ED"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.92937 5.88849L12 8.41736L7.97432 10.9851L0 8.33955L3.92937 5.88849Z",
    fill: "#EFF4FD"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0706 5.88849L12 8.41736L16.0257 10.9851L24 8.33955L20.0706 5.88849Z",
    fill: "#EDF1F9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 9.45211,
    y1: 4.09102,
    x2: 8.3513,
    y2: 8.67383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00289017,
    stopColor: "#606673",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#373C47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 9.45211,
    y1: 4.09102,
    x2: 8.3513,
    y2: 8.67383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00289017,
    stopColor: "#606673",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#373C47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 5.73859,
    y1: 12.9846,
    x2: 7.67747,
    y2: 7.50841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00289017,
    stopColor: "#6C80AA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D6A86"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 16.3556,
    y1: 14.4804,
    x2: 16.5081,
    y2: 7.53127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00289017,
    stopColor: "#314F91",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#324264"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDefaultProductIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/default-product-icon.5287b487.svg";
export { ForwardRef as ReactComponent };